import YunJi from '@/assets/js/YunJi'
import * as Http from '@/pages/commodity/api/category'

export default {
  namespaced: true,
  state: {
    appCont: YunJi.getUrlParams('appCont'), // 0-H5 2-买家 1-卖家
    menuData: [],
    categoryId: null, // 类目Id,用来获取品牌列表
    brandList: [], // 品牌列表
    isReq: 0, // 是否请求中
    isErr: 0 // 请求是否异常
  },
  mutations: {
    SETMENUDATA(state, data) {
      state.menuData = [].concat(data)
    },
    SETBRANDLIST(state, data) {
      state.brandList = [].concat(data)
    },
    SETCATEGORYID(state, data) {
      state.categoryId = data
    },
    SETISREQ(state, data) {
      state.isReq = data
    },
    SETISERR(state, data) {
      state.isErr = data
    }
  },
  actions: {
    // 获取一级类目列表(类目下面有品牌墙品牌的类目)
    queryBrandMenu({ commit, state }) {
      return new Promise( async resolve => {
        const appCont = state.appCont
        const strVersion = '0'
        commit('SETISREQ', 1)
        commit('SETISERR', 0)
        const res = await Http.queryBrandMenu({appCont, strVersion})
        commit('SETISREQ', 0)
        if (res.errorCode === 0) {
          if (res.data) commit('SETMENUDATA', res.data)
        } else {
          commit('SETISERR', 1)
        }
        resolve()
      })
    },
    // 获取品牌列表
    queryBrandList({ commit, state }) {
      return new Promise(async resolve => {
        const appCont = state.appCont
        const strVersion = '0'
        let param = {appCont, strVersion}
        if (state.categoryId >= 0) param.categoryId = state.categoryId
        commit('SETISREQ', 1)
        commit('SETISERR', 0)
        commit('SETBRANDLIST', [])
        const res = await Http.queryBrandList(param)
        commit('SETISREQ', 0)
        if (res.errorCode === 0) {
          if (res.data) commit('SETBRANDLIST', res.data)
        } else {
          commit('SETISERR', 1)
        }
        resolve()
      })
    }
  }
}